import { Form, Input, Modal } from 'antd';
import { useCreate } from '@refinedev/core';
import { useDocumentationStore } from '../documentation-store';
import { useParams } from 'react-router-dom';

export const ModalRejectDocument = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const { mutateAsync: rejectDocument } = useCreate();
  const modal = useDocumentationStore(s => s.modal);
  const editDocument = useDocumentationStore(s => s.editDocument);
  const closeModal = useDocumentationStore(s => s.closeModal);
  const queryHandler = useDocumentationStore(s => s.queryHandler);

  const handleOk = () => {
    if (!editDocument) {
      return null;
    }
    rejectDocument({
      resource: `documentations/${id}/documents/${editDocument.id}/reject`,
      values: { feedback: form.getFieldValue('feedback') },
      errorNotification: {
        type: 'error',
        message: 'Ocorreu algum erro interno no serviço',
        description: 'Erro ao rejeitar documento!'
      },
      successNotification: {
        type: 'success',
        description: 'Documento rejeitado',
        message: `O documento foi rejeitado com sucesso`
      }
    })
      .then(() => {
        form.resetFields();
        queryHandler();
        closeModal();
      })
      .catch(() => null);
  };

  return (
    <Modal
      visible={modal === 'reject'}
      title="Confirmação de rejeição"
      okText="Rejeitar"
      cancelText="Não"
      okButtonProps={{
        danger: true
      }}
      onCancel={() => closeModal()}
      onOk={() => handleOk()}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="feedback"
          label="Por que a documentação está sendo indeferida?"
        >
          <Input.TextArea placeholder="Informe o motivo da rejeição" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
